import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactCard = ({ type, name, phone, address, city, country }) => {
  const isReceiver = type === 'receiver';
  
  return (
    <div className="bg-card border border-border rounded-lg p-5">
      <div className="flex items-center space-x-3 mb-4">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
          isReceiver ? 'bg-accent/10' : 'bg-primary/10'
        }`}>
          <Icon 
            name={isReceiver ? 'UserCheck' : 'User'} 
            size={20} 
            className={isReceiver ? 'text-accent' : 'text-primary'}
          />
        </div>
        <h3 className="text-lg font-semibold text-foreground">
          {isReceiver ? 'Destinataire' : 'Expéditeur'}
        </h3>
      </div>
      <div className="space-y-3">
        {name && (
          <div className="flex items-start space-x-3">
            <Icon name="User" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
            <span className="text-sm text-foreground">{name}</span>
          </div>
        )}
        
        {phone && (
          <div className="flex items-start space-x-3">
            <Icon name="Phone" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
            <span className="text-sm text-foreground">{phone}</span>
          </div>
        )}
        
        {(address || city) && (
          <div className="flex items-start space-x-3">
            <Icon name="MapPin" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
            <div className="text-sm text-foreground">
              {address && <div>{address}</div>}
              {(city || country) && (
                <div className="text-muted-foreground mt-1">
                  {[city, country]?.filter(Boolean)?.join(', ')}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactCard;